// Function to format the JSON string to key-value pairs
export function formatJsonToKeyValue(json: Object): string {
  const jsonStr = JSON.stringify(json)

  // Remove the curly braces at the beginning and end of the string
  let trimmedStr = jsonStr.replace(/^{|}$/g, '');

  // Replace commas with line breaks
  let lineBreakStr = trimmedStr.replace(/,\s*/g, '\n');

  // Replace colons with a colon followed by a space for better readability
  let formattedStr = lineBreakStr.replace(/:\s*/g, ': ');

  return formattedStr;
}